/*
 * @Author: zyy
 * @Date: 2023-03-15 10:56:39
 * @LastEditors: zyy
 * @LastEditTime: 2023-03-15 11:05:15
 * @Description: default
 */
import shopRequests from "../shopRequest";
import Qs from 'qs'
export default {
    // 订单列表
    submit(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_view_json/edit', {
            params,
        })
    },
    list(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_view_json/index', {
            params,
        })
    },
    info(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_view_json/detail', {
            params,
        })
    }
}